import React, { FunctionComponent } from 'react'
import * as S from './styled'

type OwnProps = {
  handleClick: React.MouseEventHandler<HTMLAnchorElement>
  text: string
}

type Props = OwnProps

const LinkButton: FunctionComponent<Props> = ({ handleClick, text }) => {
  return <S.LinkButton onClick={handleClick}>{text}</S.LinkButton>
}
export default LinkButton
